import { USER_DATA_CHANGED, USER_WITHDREW } from '@/libs/constant/PostMessage';

export const postUserDataChagedMessage = () => {
  window.opener?.postMessage(
    {
      type: USER_DATA_CHANGED,
    },
    '*',
  );
};

export const postUserWithdrewMessage = () => {
  window.opener?.postMessage(
    {
      type: USER_WITHDREW,
    },
    '*',
  );
};
